import { Validators } from '@angular/forms'
import { Countries, Sexes } from '@mmx/shared'
import moment from 'moment'

import {
  AddressQuestion,
  DateQuestion,
  DropdownQuestion,
  FileQuestion,
  PhoneQuestion,
  Question,
  Questions,
} from '../../classes/question'

export function getPatientInformationQuestions(
  customQuestions: Questions,
  hasGuarantor: boolean,
): Questions {
  const defaultQuestions: Questions = [
    new FileQuestion({
      label: `patient-intake.patient-information.field-identification`,
      key: 'governmentIdCard',
      flex: '100',
    }),

    new Question({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-name'
        : 'patient-intake.patient-information.field-name',
      hint: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-name-hint'
        : 'patient-intake.patient-information.field-name-hint',
      key: 'givenName',
      autocomplete: hasGuarantor ? 'off' : 'given-name',
      required: true,
      flex: '50',
    }),

    new Question({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-last-name'
        : 'patient-intake.patient-information.field-last-name',
      hint: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-last-name-hint'
        : 'patient-intake.patient-information.field-last-name-hint',
      key: 'familyName',
      autocomplete: hasGuarantor ? 'off' : 'family-name',
      required: true,
      flex: '50',
    }),

    new PhoneQuestion({
      label: 'patient-intake.patient-information.field-phone-number',
      hint: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-phone-number-hint'
        : 'patient-intake.patient-information.field-phone-number-hint',
      key: 'phoneNumber',
      autocomplete: 'tel',
      subscribeSms: true,
      subscribeSmsText: 'patient-intake.patient-information.field-phone-check',
      subscribeSmsKey: 'receiveSmsAlert',
      flex: '50',
      required: true,
    }),

    new Question({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-email'
        : 'patient-intake.patient-information.field-email',
      type: 'email',
      hint: 'patient-intake.patient-information.field-email-hint',
      key: 'email',
      autocomplete: hasGuarantor ? 'off' : 'email',
      flex: '50',
      validators: [Validators.email],
    }),

    new AddressQuestion({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-address'
        : 'patient-intake.patient-information.field-address',
      key: 'address',
      autocomplete: 'on',
      options: Countries,
      states: [],
      required: true,
    }),

    new DateQuestion({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-dob'
        : 'patient-intake.patient-information.field-dob',
      key: 'dob',
      autocomplete: hasGuarantor ? 'off' : 'bday',
      flex: '50',
      max: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      required: true,
      startView: 'multi-year',
    }),

    new DropdownQuestion({
      label: hasGuarantor
        ? 'patient-intake.patient-information.field-patient-sex'
        : 'patient-intake.patient-information.field-sex',
      key: 'sex',
      autocomplete: hasGuarantor ? 'off' : 'sex',
      flex: '50',
      options: Sexes,
      required: true,
    }),
  ]

  return [...defaultQuestions, ...customQuestions]
}
